<template>
  <el-dialog
    title="区域调整"
    :visible.sync="formVisible"
    width="800px"
    :close-on-click-modal="false"
  >
    <el-form
      ref="dataForm"
      :model="form"
      label-position="right"
      size="small"
      label-width="110px"
    >
      <el-form-item prop="childDetail">
        <template slot="label">
          <span>区域</span>
        </template>
        <div
          v-for="(item, index) in form.childDetail"
          :key="index"
          class="adjust-row"
        >
          <el-cascader
            v-model="item.districtCode"
            :props="getCascaderProps(index)"
            collapse-tags
            :options="getAreaOptions(index)"
            placeholder="请选择需调整区域"
            clearable
            class="adjust-cascader"
            @change="handleAreaChange"
          ></el-cascader>
          <el-select
            v-model="item.newCityCompanyId"
            placeholder="请选择整后城市公司"
            clearable
            size="small"
            filterable
            remote
            :remote-method="searchCityCompany"
            :loading="cityCompanyLoading"
            class="adjust-select"
          >
            <el-option
              v-for="it in options.cityCompanyOptions"
              :key="it.id"
              :label="it.name"
              :value="it.id"
            ></el-option>
          </el-select>
          <div class="adjust-icons">
            <i class="el-icon-plus" @click="handleAddRow"></i>
            <i class="el-icon-minus" @click="handleDeleteRow(index)"></i>
          </div>
        </div>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="formVisible = false">取消</el-button>
      <el-button type="primary" @click="doCreate()" :loading="isLoading"
        >确认</el-button
      >
    </div>
  </el-dialog>
</template>

<script>
import CityCompanyAddrAreaApi from "@/api/sys/CityCompanyAddrArea";
import cityCompanyApi from "@/api/sys/cityCompany";

function initFormBean() {
  const formBean = {
    childDetail: [
      {
        districtCode: "",
        newCityCompanyId: ""
      }
    ]
  };
  return formBean;
}

export default {
  data() {
    return {
      formVisible: false,
      form: initFormBean(),
      options: {
        areaOptions: [],
        cityCompanyOptions: []
      },
      isLoading: false,
      cityCompanyLoading: false,
      baseCascaderProps: {
        label: "areaName",
        value: "areaCode",
        children: "child",
        multiple: true
      },
      id: null,
      currentCityCompanyName: "" // 当前城市公司名称
    };
  },
  methods: {
    // 获取地区树形结构
    changeIdentity() {
      CityCompanyAddrAreaApi.CityCompanyAddrAreaListForTree({
        cityCompanyId: this.id
      }).then(({ data }) => {
        this.options.areaOptions = data ? this.formatCascaderData(data) : [];
      });
    },
    formatCascaderData(data) {
      for (var i = 0; i < data.length; i++) {
        if (data[i].child.length < 1) {
          // children若为空数组，则将children设为undefined
          data[i].child = undefined;
        } else {
          // children若不为空数组，则继续 递归调用 本方法
          this.formatCascaderData(data[i].child);
        }
      }
      return data;
    },
    // 获取已选择的区域代码（排除指定行）
    getSelectedDistrictCodes(excludeIndex) {
      const selectedCodes = new Set();
      this.form.childDetail.forEach((item, index) => {
        if (
          index !== excludeIndex &&
          item.districtCode &&
          item.districtCode.length > 0
        ) {
          // districtCode 是数组的数组，格式为 [[provinceCode, cityCode, districtCode], ...]
          item.districtCode.forEach(codeArray => {
            if (codeArray && codeArray.length >= 3) {
              // 使用完整的路径作为唯一标识
              const codeKey = codeArray.join("-");
              selectedCodes.add(codeKey);
            }
          });
        }
      });
      return selectedCodes;
    },
    // 统计节点的所有叶子节点数量
    countLeafNodes(node) {
      if (!node.child || node.child.length === 0) {
        return 1; // 叶子节点
      }
      let count = 0;
      node.child.forEach(child => {
        count += this.countLeafNodes(child);
      });
      return count;
    },
    // 统计节点下已选择的叶子节点数量
    countSelectedLeafNodes(node, selectedCodes, path = []) {
      const currentPath = [...path, node.areaCode];
      const pathKey = currentPath.join("-");

      if (!node.child || node.child.length === 0) {
        // 叶子节点
        return selectedCodes.has(pathKey) ? 1 : 0;
      }

      let count = 0;
      node.child.forEach(child => {
        count += this.countSelectedLeafNodes(child, selectedCodes, currentPath);
      });
      return count;
    },
    // 递归标记已选择的区域为禁用
    markDisabledOptions(data, selectedCodes, path = []) {
      if (!data || !Array.isArray(data)) return;
      data.forEach(node => {
        const currentPath = [...path, node.areaCode];
        const pathKey = currentPath.join("-");

        if (!node.child || node.child.length === 0) {
          // 叶子节点：如果已选择，则禁用
          node.disabled = selectedCodes.has(pathKey);
        } else {
          // 非叶子节点：如果所有子节点都已选择，则禁用
          const totalLeafNodes = this.countLeafNodes(node);
          const selectedLeafNodes = this.countSelectedLeafNodes(
            node,
            selectedCodes,
            path
          );
          node.disabled =
            totalLeafNodes > 0 && selectedLeafNodes === totalLeafNodes;
        }

        // 递归处理子节点
        if (node.child && node.child.length > 0) {
          this.markDisabledOptions(node.child, selectedCodes, currentPath);
        }
      });
    },
    // 更新区域选项的禁用状态
    updateAreaOptionsDisabled(excludeIndex) {
      const selectedCodes = this.getSelectedDistrictCodes(excludeIndex);
      // 深拷贝数据避免影响原始数据
      const areaOptions = JSON.parse(JSON.stringify(this.options.areaOptions));
      this.markDisabledOptions(areaOptions, selectedCodes);
      return areaOptions;
    },
    // 获取级联选择器配置（动态禁用已选择区域）
    getCascaderProps(index) {
      return {
        ...this.baseCascaderProps
      };
    },
    // 获取区域选项（带禁用标记）
    getAreaOptions(index) {
      if (!this.options.areaOptions || this.options.areaOptions.length === 0) {
        return [];
      }
      return this.updateAreaOptionsDisabled(index);
    },
    // 处理区域变化，触发更新
    handleAreaChange() {
      // 区域变化时，通过重新赋值触发响应式更新
      // 这样其他行的级联选择器会重新计算禁用状态
      this.$nextTick(() => {
        // 触发响应式更新
        this.form.childDetail = [...this.form.childDetail];
      });
    },
    // 搜索城市公司
    searchCityCompany(query) {
      this.cityCompanyLoading = true;
      const params = {
        pageNo: 1,
        pageSize: query ? 100 : 20
      };
      // 如果有搜索关键词，添加到参数中
      if (query && query.trim()) {
        params.cityCompanyName = query.trim();
      }
      cityCompanyApi
        .fetchList(params)
        .then(({ data }) => {
          this.options.cityCompanyOptions = data.list || [];
          this.cityCompanyLoading = false;
        })
        .catch(() => {
          this.cityCompanyLoading = false;
        });
    },
    // 添加行
    handleAddRow() {
      this.form.childDetail.push({
        districtCode: "",
        newCityCompanyId: ""
      });
    },
    // 删除行
    handleDeleteRow(index) {
      if (this.form.childDetail.length <= 1) {
        this.$message.warning("至少保留一行");
        return;
      }
      this.form.childDetail.splice(index, 1);
    },
    // 根据区域代码获取区域名称
    getAreaNameByCode(codeArray, options = null) {
      if (!codeArray || codeArray.length < 3) return "";
      const opts = options || this.options.areaOptions;
      let current = opts;
      const names = [];

      for (let i = 0; i < codeArray.length; i++) {
        const code = codeArray[i];
        const found = current.find(item => item.areaCode === code);
        if (found) {
          names.push(found.areaName);
          current = found.child || [];
        } else {
          break;
        }
      }

      return names.join("/");
    },
    // 格式化数据 - 按新城市公司分组
    formatAdjustData(data) {
      // 按新城市公司ID分组
      const groupedByCityCompany = {};

      data.forEach(item => {
        if (
          item.districtCode &&
          item.districtCode.length > 0 &&
          item.newCityCompanyId
        ) {
          const bCityCompanyId = item.newCityCompanyId;

          // 获取新城市公司信息
          const bCityCompany = this.options.cityCompanyOptions.find(
            c => c.id === bCityCompanyId
          );

          if (!groupedByCityCompany[bCityCompanyId]) {
            groupedByCityCompany[bCityCompanyId] = {
              aCityCompanyId: this.id,
              aCityCompanyName: this.currentCityCompanyName || "",
              bCityCompanyId: bCityCompanyId,
              bCityCompanyName: bCityCompany ? bCityCompany.name : "",
              addrList: []
            };
          }

          // 处理每个区域
          item.districtCode.forEach(codeArray => {
            if (codeArray && codeArray.length >= 3) {
              const districtCode = codeArray[2]; // 区编码
              const addrName = this.getAreaNameByCode(codeArray); // 地址全称

              groupedByCityCompany[bCityCompanyId].addrList.push({
                addrName: addrName,
                districtCode: districtCode
              });
            }
          });
        }
      });

      // 转换为数组
      return Object.values(groupedByCityCompany);
    },
    /**
     * 重置表单
     */
    resetForm() {
      this.options.areaOptions = [];
      this.options.cityCompanyOptions = [];
      this.form = initFormBean();
    },
    handleUpdate(row) {
      this.id = row.id;
      this.currentCityCompanyName = row.name || ""; // 保存当前城市公司名称
      this.resetForm();
      this.formVisible = true;
      this.$nextTick(() => {
        this.changeIdentity();
        // 首次加载20条城市公司数据
        this.searchCityCompany("");
      });
    },
    doCreate() {
      // 验证表单
      let hasError = false;
      for (let i = 0; i < this.form.childDetail.length; i++) {
        const item = this.form.childDetail[i];
        if (!item.districtCode || item.districtCode.length === 0) {
          this.$message.error(`第${i + 1}行：请选择需调整区域`);
          hasError = true;
          break;
        }
        if (!item.newCityCompanyId) {
          this.$message.error(`第${i + 1}行：请选择整后城市公司`);
          hasError = true;
          break;
        }
      }
      if (hasError) return;

      this.isLoading = true;
      const arr = this.formatAdjustData(this.form.childDetail);

      if (arr.length === 0) {
        this.$message.error("请至少填写一条完整的调整信息");
        this.isLoading = false;
        return;
      }

      // 调用调整区域接口 - 直接传数组
      CityCompanyAddrAreaApi.changeCityArea(arr)
        .then(() => {
          this.$message.success("操作成功");
          this.formVisible = false;
          this.$emit("created");
          this.isLoading = false;
        })
        .catch(res => {
          this.isLoading = false;
        });
    }
  }
};
</script>
<style lang="scss" scoped>
.adjust-row {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  gap: 10px;
}

.adjust-cascader {
  flex: 1;
}

.adjust-select {
  flex: 1;
}

.adjust-icons {
  display: flex;
  gap: 10px;
  i {
    cursor: pointer;
    font-size: 18px;
    color: #409eff;
    &:hover {
      color: #66b1ff;
    }
  }
}

::v-deep .el-cascader {
  width: 100%;
}

::v-deep .el-select {
  width: 100%;
}
</style>
